import { Auth } from 'aws-amplify';
import { postBodyMdsService, postBodyMdsServiceWithOutVerification } from "./oauth.service";
import config from "../config/application";
import env from "../config/env";

//url
const loginUrl='login';
const logoutUrl='logout';
const registerUrl='register_user';

class LoginService {
    login = async () => {

        let user = await Auth.currentAuthenticatedUser();
        if (user === undefined) {
            return null;
        } else {

            sessionStorage.setItem('username', user.getUsername());
            sessionStorage.setItem('name', user.getUsername());

            return user;
        }

    }
    registerUser = (jsonLogin) => {
        // register_user no lleva ?env: el usuario es el mismo en todos los ambientes.
        const url = `${config.data.security.login.url}/${registerUrl}`;
        return postBodyMdsService(url, jsonLogin);
    }
    loginAD = (jsonLogin) => {
        const url = `${config.data.security.login.url}/${loginUrl}${env.mds.query}`;
        return postBodyMdsService(url, jsonLogin);
    }
    logout = (jsonLogout) => {
        const url = `${config.data.security.login.url}/${logoutUrl}${env.mds.query}`;
        return postBodyMdsServiceWithOutVerification(url, jsonLogout);
    }

}


export default new LoginService();